import React from "react"
import { FileProtectOutlined } from "@ant-design/icons"
import { VCreateClient, VEditClient, VListClients, VViewClient } from "."
import { EOpusPermission } from "contexts/authorization/hooks/use-opus-permissions"

export const CLIENTS_ROUTES = [
  {
    path: "/clients",
    component: VListClients
  },
  {
    path: "/clients/create",
    component: VCreateClient
  },
  {
    path: "/clients/edit/:clientId([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})",
    component: VEditClient
  },
  {
    path: "/client/:id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/:subpage?",
    component: VViewClient
  }
]

export const CLIENTS_NAVIGATION = [
  {
    title: "Clients",
    path: "/clients",
    childPaths: ["/clients", "/client"],
    submenu: false,
    permission: `${EOpusPermission.ClientManagement}:true`,
    icon: <FileProtectOutlined twoToneColor="#ccc" />,
    iconActive: <FileProtectOutlined twoToneColor="#1890ff" />
  }
]
